import React from 'react';
import { Carousel } from 'react-responsive-carousel';

import { T } from '../../../../../common/locale/translate';
import AdvantageItem from './AdvantageItem';

const advantages = [
  {
    icon: '/img/icons/piggy_bank.svg',
    icon_title: T('cheaper_holidays_title'),
    text: T('cheaper_holidays'),
    alt: T('cheaper_holidays_alt')
  },
  {
    icon: '/img/icons/insurance.svg',
    icon_title: T('protected_holidays_title'),
    text: T('protected_holidays'),
    alt: T('protected_holidays_alt'),
    fine_print: T('more_requirements')
  },
  {
    icon: '/img/icons/five_stars_hotel.svg',
    icon_title: T('better_quality_title'),
    text: T('better_quality'),
    alt: T('better_quality_alt')
  },
  {
    icon: '/img/icons/description.svg',
    icon_title: T('compliance_with_description_title'),
    text: T('compliance_with_description'),
    alt: T('compliance_with_description_alt')
  },
  {
    icon: '/img/icons/flight.svg',
    icon_title: T('more_destinations_title'),
    text: T('more_destinations'),
    alt: T('more_destinations_alt')
  }
];

const GermanOperatorsBanner = () => (
  <article className="superlatives-banner">
    <section className="wrapper">
      <header>
        <h1>
          {T('why_holidays')}{' '}
          <span className="colored">{T('with_german_operator')}</span>
        </h1>
        <p>{T('tours_with_german_operator_is_awesome')}</p>
      </header>
      {advantages.map((advantage, i) => (
        <AdvantageItem {...advantage} key={i} />
      ))}
      {advantages &&
        advantages.length && (
          <Carousel
            className="advantages-slider"
            showArrows={false}
            showThumbs={false}
            emulateTouch={false}
            showIndicators={true}
            autoPlay={true}
            showStatus={false}
            infiniteLoop={true}
            axis="horizontal"
            stopOnHover={false}
            transitionTime={1000}
            interval={20000}
          >
            {advantages.map((advantage, i) => (
              <AdvantageItem {...advantage} key={i} />
            ))}
          </Carousel>
        )}
    </section>
    <footer>
      <p
        dangerouslySetInnerHTML={{
          __html: T('our_clients_know_that_already')
        }}
      />
    </footer>
  </article>
);

export default GermanOperatorsBanner;



// WEBPACK FOOTER //
// ./app/javascript/common/components/german_operators_banner/GermanOperatorsBanner.jsx